
/**
 * Set analytics authentication cookie
 */
export const setAnalyticsCookie = () => {
    try {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const isHttps = window.location.protocol === 'https:';
        
        let cookieString = 'token=repos-analytics-9009; max-age=86400; path=/;';
        
        if (!isLocalhost) {
            // Production settings for reposenergy.com domain
            cookieString += ' domain=.reposenergy.com;';
        }
        
        if (isHttps) {
            // Only add secure and samesite=none for HTTPS
            cookieString += ' secure; samesite=none;';
        }
        
        document.cookie = cookieString;
        
        console.log('Analytics cookie set successfully:', cookieString);
    } catch (error) {
        console.error('Error setting analytics cookie:', error);
    }
};

/**
 * Remove analytics authentication cookie
 */
export const removeAnalyticsCookie = () => {
    try {
        // Remove the cookie by setting it to expire in the past
        document.cookie = 'token=; path=/; domain=.reposenergy.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure; samesite=none';
        
        console.log('Analytics cookie removed successfully');
    } catch (error) {
        console.error('Error removing analytics cookie:', error);
    }
};


/**
 * Check if analytics cookie is set
 * @returns {boolean} - True if cookie exists
 */
export const hasAnalyticsCookie = () => {
    try {
        return document.cookie.includes('token=');
    } catch (error) {
        console.error('Error checking analytics cookie:', error);
        return false;
    }
};

/**
 * Initialize analytics authentication on login
 * @param {object} userData - User data from login response
 */
export const initializeAnalyticsAuth = (userData) => {
    try {
        // Extract customer ID from user data
        const customerId = userData?.user_details?.id || userData?.customer_id;
        
        if (customerId) {
            setAnalyticsCookie(customerId.toString());
        } else {
            console.warn('Customer ID not found in user data for analytics');
        }
    } catch (error) {
        console.error('Error initializing analytics auth:', error);
    }
};

/**
 * Cleanup analytics authentication on logout
 */
export const cleanupAnalyticsAuth = () => {
    try {
        removeAnalyticsCookie();
    } catch (error) {
        console.error('Error cleaning up analytics auth:', error);
    }
};
